import { CommonModule } from '@angular/common';
import { Component, EnvironmentInjector, Inject, Input } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import { DoughnutChartComponent } from 'src/app/shared/components/loan-calulator/doughnut-chart/doughnut-chart.component';
import { LoanCalulatorComponent } from 'src/app/shared/components/loan-calulator/loan-calulator.component';
import { LoanRequestUnauthorizedModalComponent } from './loan-request-unauthorized-modal/loan-request-unauthorized-modal.component';
import { ModalService } from '@indice/ng-components';
import { LoanCalculatorValues, LoanService, LoanValues } from 'src/app/services/loan.service';
import { tap } from 'rxjs';
import { localizeRoute } from 'src/app/shared/utilities/localizeRoutes';

@Component({
  selector: 'app-financing-section',
  standalone: true,
  imports: [LoanCalulatorComponent, DoughnutChartComponent, CommonModule, TranslocoPipe],
  templateUrl: './financing-section.component.html'
})
export class FinancingSectionComponent {
  @Input() propertyValue!: number;
  @Input() isLoggedIn: boolean | null = null;
  @Input() isAuctioned: boolean | null = null;

  protected initialCalcValues: LoanCalculatorValues | undefined;
  protected latestLoanValues: LoanValues | undefined;
  protected propertyId = this._activatedRoute.snapshot.params['propertyId'];
  protected activeLang = 'el';

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _modalService: ModalService,
    private _router: Router,
    private _loanService: LoanService,
    private translocoService: TranslocoService,
    @Inject(EnvironmentInjector) private envInjector: EnvironmentInjector
  ) {

  }
  ngOnInit() {
    this.translocoService.langChanges$.subscribe(lang => {
      this.activeLang = lang;
    })
    this.initialCalcValues = new LoanCalculatorValues(this.propertyValue);
    this._loanService.currentLoanValues.pipe(
      tap((t) => {
        this.latestLoanValues = t;
      })
    ).subscribe();
  }

  protected askFinancialServices(route: string): void {
    const params = {
      property: this.propertyId,
      propertyValue: this.propertyValue,
      rennovationCosts: this.latestLoanValues?.loanCalculatorValues.rennovationCosts,
      loanAmount: this.latestLoanValues?.loanCalculatorValues.loanAmount,
      loanDuration: this.latestLoanValues?.loanCalculatorValues.loanDuration,
      loanFixedDuration: this.latestLoanValues?.loanCalculatorValues.loanFixedDuration
    };
    if (this.isLoggedIn) {
      this._router.navigate([localizeRoute(route, this.envInjector)], {
        queryParams: params,
        queryParamsHandling: 'merge',
        skipLocationChange: false,
      });
      return;
    }
    let redirectUrl = `${route}?property=${this.propertyId}`;
    if (this.propertyValue) {
      redirectUrl = `${redirectUrl}&propertyValue=${this.propertyValue}`;
    }
    this._modalService.show(LoanRequestUnauthorizedModalComponent, {
      initialState: {
        redirectUrl: redirectUrl,
      },
    });
  }
}
